import { render, staticRenderFns } from "./ManageWorkspacesPage.vue?vue&type=template&id=1883416c&scoped=true"
import script from "./ManageWorkspacesPage.vue?vue&type=script&lang=ts"
export * from "./ManageWorkspacesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1883416c",
  null
  
)

export default component.exports